module.exports = {
  barcode: {
    description: 'linha digitavel'
  },
  paymentDate: {
    description: 'data de pagamento'
  },
  description: {
    description: 'descricao'
  },
  integrationId: {
    description: 'id integracao',
    optional: true
  }
};
